export default __webpack_public_path__ + "static/media/5.01c11c95.jpg";